import { useCallback, useRef } from 'react';
/**
 * This React custom hook returns a function that returns a zIndex for a given spotId and latitude.
 *
 * @returns {function({spotId: string, latitude: number}): number} - A function that returns a zIndex for a given spotId and latitude.
 */
const useZIndex = () => {
    const zIndexModifiers = useRef({});
    const zIndexBySpot = useRef({});
    const getZIndex = useCallback(({ spotId, latitude }) => {
        if (!Object.prototype.hasOwnProperty.call(zIndexBySpot.current, spotId)) {
            const zIndex = Number(Math.abs(latitude).toFixed(3)) * 1000;
            if (Object.prototype.hasOwnProperty.call(zIndexModifiers.current, zIndex)) {
                zIndexModifiers.current[zIndex] += 1;
            }
            else {
                zIndexModifiers.current[zIndex] = 0;
            }
            zIndexBySpot.current[spotId] =
                zIndex + zIndexModifiers.current[zIndex];
        }
        return zIndexBySpot.current[spotId];
    }, []);
    return getZIndex;
};
export default useZIndex;
